import api from "../services/api";

async function getPlaces(user, allPlaces) {
  let userPlaces = user?.store?.split(",")?.map(Number);
  if (Array.isArray(userPlaces) && userPlaces[0] === 0) {
    userPlaces = undefined;
  }

  let filteredPlaces;

  try {
    const res = await api.get("card_places");
    const { data } = res;

    if (userPlaces && !allPlaces) {
      filteredPlaces = data?.places.filter(
        (place) => userPlaces.includes(place.id) && place.id >= 1
      );
    } else {
      filteredPlaces = data?.places.filter((place) => place.id >= 1);
    }

    return filteredPlaces;
  } catch (error) {
    console.error("Error fetching data:", error);
  }

  return false;
}

export { getPlaces };
